import * as React from 'react';
import { SecondaryMenu, Translate } from '../../components';
import { Locale, translate } from '../../translations';

import './blog-landing-filter-menu.scss';

interface LandingFilterMenuProperties {
  toggleFilter: (filter: string) => void;
  categories: any;
  activeFilters: string[];
}
export const LandingPageFilterMenu = ({
  categories,
  toggleFilter,
  activeFilters,
}: LandingFilterMenuProperties) => (
  <SecondaryMenu label="Filters">
    <div className="landing-filters-list">
      {categories.map((category, index) => (
        <FiltersList
          key={index}
          toggleFilter={toggleFilter}
          category={category}
          activeFilters={activeFilters}
        />
      ))}
    </div>
  </SecondaryMenu>
);

const FiltersList = ({ category, toggleFilter, activeFilters }) => {
  return (
    <div className="landing-filters-section">
      <div className="landing-filters-section--title">
        <Translate id={category.title} />
      </div>
      {category.labels.map((label, index) => {
        const englishLabel = translate(Locale.English, label) as string;

        return (
          <label key={index}>
            <input
              type="checkbox"
              checked={activeFilters.includes(englishLabel)}
              onChange={() => toggleFilter(englishLabel)}
            />
            <Translate id={label} />
            <span className="checkmark" />
          </label>
        );
      })}
    </div>
  );
};
